import { render, staticRenderFns } from "./UserProfileView.vue?vue&type=template&id=43912b78&scoped=true"
import script from "./UserProfileView.vue?vue&type=script&lang=js"
export * from "./UserProfileView.vue?vue&type=script&lang=js"
import style0 from "./UserProfileView.vue?vue&type=style&index=0&id=43912b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43912b78",
  null
  
)

export default component.exports